import { FC, useId } from "react";

import { WarningModal } from "@/shared/modals";
import { SecondaryText } from "@/shared/ui/Typography";

interface ICarrierModal {
    isModalCarrierOpened: boolean;
    onConfirmCarrier: () => void;
    onCancelCarrier: () => void;
}

export const CarrierModal: FC<ICarrierModal> = ({
    isModalCarrierOpened,
    onConfirmCarrier,
    onCancelCarrier,
}) => {
    const modalKey = useId();
    return (
        <WarningModal
            modalKey={modalKey}
            width="92%"
            isModalOpened={isModalCarrierOpened}
            confirm={onConfirmCarrier}
            cancel={onCancelCarrier}
        >
            <SecondaryText
                fontSize={16}
                fontWeight="400"
                style={{ lineHeight: "130%", marginTop: "16px" }}
            >
                Відвантаження буде здійснено із залишків Торгового Агента. Перед
                оформленням замовлення, зв&apos;яжіться з оператором і
                переконайтесь, що залишки наявні.
            </SecondaryText>
        </WarningModal>
    );
};
